import React from 'react';

import { Button, Card, Descriptions, Flex } from 'antd';
import dayjs from 'dayjs';
import { t } from 'i18next';

import { useNotification } from 'segments/hooks';

import { useDeleteBookingWaitMutation } from '../store/Api';
import { BookingWaitInfo } from '../store/types';

interface Props {
  waiterInfo: BookingWaitInfo;
  editWaiting: (ids: number[]) => void;
}

export function BookingWaiter({ waiterInfo, editWaiting }: Props) {
  const [deleteWait, { isError: isDeleteError, isLoading: isDeleteLoading, isSuccess: isDeleteSuccess, error: deleteError }] = useDeleteBookingWaitMutation();

  const waitingStartTime = dayjs(waiterInfo.startTime).format('HH:mm');
  const waitingEndTime = dayjs(waiterInfo.endTime).format('HH:mm');

  useNotification({
    isSuccess: isDeleteSuccess,
    isError: isDeleteError,
    error: deleteError
  });

  const handleDeleteWait = () => {
    deleteWait(waiterInfo.id);
  };

  return (
    <Card title={waiterInfo.userName ?? waiterInfo.note} size="small">
      <Descriptions column={2}>
        <Descriptions.Item label={t('booking-wait.description.time')}>{waitingStartTime}-{waitingEndTime}</Descriptions.Item>
        {
          waiterInfo.userName !== null && waiterInfo.note !== null && (
            <Descriptions.Item label={t('booking-wait.description.note')}>{waiterInfo.note}</Descriptions.Item>
          )
        }
        {
          waiterInfo.userPhone !== null && (
            <Descriptions.Item label={t('booking-wait.description.phone')}>{waiterInfo.userPhone}</Descriptions.Item>
          )
        }
        {
          waiterInfo.userEmail !== null && (
            <Descriptions.Item label={t('booking-wait.description.mail')}>{waiterInfo.userEmail}</Descriptions.Item>
          )
        }
      </Descriptions>
      <Flex style={{ marginTop: '10px' }} justify='flex-end'>
        <Button size='small' disabled={isDeleteLoading} onClick={() => editWaiting([waiterInfo.id])}>
          {t('booking-wait.button.edit')}
        </Button>
        < Button
          danger
          type='primary'
          size='small'
          disabled={isDeleteLoading}
          style={{ marginLeft: '8px' }}
          onClick={handleDeleteWait}
        >
          {t('booking-wait.button.delete')}
        </Button>
      </Flex>
    </Card >
  );
}

